var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEthereum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1027,
    height: 1027,
    viewBox: "0 0 1027 1027",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M520.729 1019.72C796.043 1019.72 1019.23 796.531 1019.23 521.217C1019.23 245.903 796.043 22.717 520.729 22.717C245.415 22.717 22.229 245.903 22.229 521.217C22.229 796.531 245.415 1019.72 520.729 1019.72Z",
    fill: "black",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M500.729 12C770.647 12 989.459 230.7 989.459 500.476C989.459 770.252 770.647 988.953 500.729 988.953C230.811 988.953 12 770.254 12 500.476C12 230.698 230.811 12 500.729 12Z",
    fill: "url(#paint0_linear_61_31)",
    stroke: "#283155",
    strokeWidth: 24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M514.95 92.817C748.067 92.817 937.05 281.697 937.05 514.692C937.05 747.687 748.067 936.566 514.95 936.566C281.833 936.566 92.856 747.686 92.856 514.69C92.856 281.694 281.834 92.817 514.95 92.817Z",
    fill: "#354171"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M501.843 87.906C730.432 87.906 915.743 273.119 915.743 501.59C915.743 730.061 730.429 915.273 501.843 915.273C273.257 915.273 87.943 730.061 87.943 501.59C87.943 273.119 273.253 87.906 501.843 87.906Z",
    fill: "url(#paint1_linear_61_31)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M521.235 107.132C292.559 107.132 107.181 292.414 107.181 520.972C107.046 626.059 147.048 727.231 219.013 803.811C138.36 728.3 87.9449 620.917 87.9449 501.746C87.9449 273.189 273.323 87.9061 501.999 87.9061C558.667 87.8387 614.742 99.4342 666.736 121.971C718.729 144.508 765.528 177.504 804.221 218.906C727.57 146.967 626.356 106.99 521.235 107.132Z",
    fill: "url(#paint2_linear_61_31)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.391 579.841L260.029 546.555L499.188 687.068L741.559 546.555L756.707 580.855L517.549 911.153L278.391 579.841ZM282.429 540.447L517.549 677.817L756.434 538.427L518.558 151.192L500.565 121.804L263.701 507.524L282.429 540.447Z",
    fill: "url(#paint3_linear_61_31)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.029 548.617L499.188 688.009L738.346 549.626L499.188 879.926L260.029 548.617ZM264.066 509.223L499.188 646.595L735.319 507.202L500.197 121.345L264.066 509.223Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M499.188 688.009L738.346 549.626L499.188 879.926V688.009ZM264.066 509.222L499.188 646.595L735.319 507.202L500.197 121.345L499.756 398.374L264.066 509.222Z",
    fill: "#C8CEE4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M499.188 646.595L735.319 507.202L499.756 398.374L499.188 646.595Z",
    fill: "#929DC8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_61_31",
    x1: 500.729,
    y1: 988.967,
    x2: 500.729,
    y2: 11.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E3B6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8995C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_61_31",
    x1: 501.838,
    y1: 915.279,
    x2: 501.838,
    y2: 87.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37457B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2B0E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_61_31",
    x1: 446.088,
    y1: 803.811,
    x2: 446.088,
    y2: 87.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#929DC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8CEE4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_61_31",
    x1: 508.37,
    y1: 911.155,
    x2: 508.37,
    y2: 121.811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B79B0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEthereum);
export default __webpack_public_path__ + "static/media/icon-ethereum.c7ad08a2f0b71dc67b0aa58fb19646f8.svg";
export { ForwardRef as ReactComponent };